import { makeStyles } from '@material-ui/styles'
import { ChevronRightRounded } from '@mui/icons-material'
import { Breadcrumbs, Button, Link, Stack, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { GrUpdate } from 'react-icons/gr'
// import { Link } from 'react-router-dom'

export default function Header({handleOnHeaderButtonClick}: {handleOnHeaderButtonClick: ()=>void}) {

    const classes = useStyles()

    return(

        <Stack direction="row" justifyContent="space-between" alignItems="center" >
                
            <Stack direction="column">
                <Typography variant="h6" sx={{color: "grey.200", fontWeight: "bold" }}>Account Settings</Typography>
                <Breadcrumbs sx={{color: grey[500] }} separator={<ChevronRightRounded sx={{color:grey[500]}} />}  >
                    <Link className={classes.links} >
                        Settings
                    </Link>
                    <Link className={classes.link_current} >
                        Account Settings
                    </Link>
                </Breadcrumbs>
            </Stack>

            <Button onClick={handleOnHeaderButtonClick} className={classes.button} variant="contained" title="Settings" startIcon={<GrUpdate size="14px" />} >
                Update
            </Button>
        </Stack>

    )
}

const useStyles= makeStyles(theme=>({

    button:{
        color: '#1A1B41',
        boxShadow: "none",
        backgroundColor: '#baff29',
        textTransform: "capitalize",
        '&:hover': {
            backgroundColor: '#baff29'
        },
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
    },
    links:{
        color: grey[200],
        textDecoration: "none",
        fontSize: "13px"
    },
    link_current:{
        color: grey[500],
        textDecoration: "none",
        fontSize: "13px"
    }

}))
